import { useEffect, useState } from "react";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { CAMPI_FORNITORE, PERCORSO_FORNITORE, normalizzaFornitore, campiLegaliMancanti } from "../utils/fornitore";

/**
 * Pannello del Platform Owner: dati del soggetto che gestisce Nexiora. È l'unico punto in
 * cui si inseriscono; app, email e sito vetrina li leggono da qui (piattaforma/fornitore).
 * Tutti i campi sono facoltativi: si possono lasciare vuoti durante test e sviluppo.
 */
export default function DatiFornitoreModal({ onClose, addToast }) {
  const [dati, setDati] = useState(null);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    getDoc(doc(db, ...PERCORSO_FORNITORE))
      .then(s => setDati(s.exists() ? s.data() : {}))
      .catch(() => setDati({}));
  }, []);

  if (!dati) return null;
  const mancanti = campiLegaliMancanti(normalizzaFornitore(dati));
  const inp = { width:"100%", padding:"8px 10px", background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.12)", borderRadius:8, color:"#fff", fontSize:13, fontFamily:"'Inter',sans-serif", boxSizing:"border-box" };

  const salva = async () => {
    setSalvando(true);
    try {
      const pulito = {};
      CAMPI_FORNITORE.forEach(({ key }) => { pulito[key] = (dati[key] || "").trim(); });
      await setDoc(doc(db, ...PERCORSO_FORNITORE), { ...pulito, aggiornatoIl: serverTimestamp() }, { merge: true });
      addToast?.("Dati del fornitore salvati: app, email e sito li useranno da subito", "success");
      onClose();
    } catch (e) {
      addToast?.("Salvataggio non riuscito: controlla di aver pubblicato le Regole Firestore aggiornate", "error");
      setSalvando(false);
    }
  };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", zIndex:9999, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ background:"#14142a", border:"1px solid rgba(255,255,255,0.1)", borderRadius:16, width:"100%", maxWidth:560, maxHeight:"90vh", overflowY:"auto", padding:24, color:"#fff", fontFamily:"'Inter',sans-serif" }}>
        <div style={{ fontSize:17, fontWeight:800, marginBottom:4 }}>Dati del fornitore della piattaforma</div>
        <div style={{ fontSize:12, color:"rgba(255,255,255,0.5)", marginBottom:14, lineHeight:1.5 }}>
          Il soggetto che gestisce Nexiora. Compaiono nelle pagine legali del sito, nel piè di pagina delle email e dove servono nell'app.
          Si possono lasciare vuoti durante i test: nulla si blocca.
        </div>
        {mancanti.length > 0 && (
          <div style={{ fontSize:12, background:"rgba(217,119,6,0.15)", border:"1px solid rgba(217,119,6,0.4)", color:"#fcd34d", borderRadius:8, padding:"8px 12px", marginBottom:14 }}>
            Da definire prima della pubblicazione commerciale: {mancanti.join(", ")}.
          </div>
        )}
        <div style={{ display:"grid", gap:10 }}>
          {CAMPI_FORNITORE.map(c => (
            <label key={c.key} style={{ fontSize:11, color:"rgba(255,255,255,0.55)", display:"grid", gap:4 }}>
              {c.label}{c.legale ? " *" : ""}
              <input value={dati[c.key] || ""} onChange={e => setDati(d => ({ ...d, [c.key]: e.target.value }))} style={inp}/>
            </label>
          ))}
        </div>
        <div style={{ fontSize:10.5, color:"rgba(255,255,255,0.4)", marginTop:8 }}>* dati legali · se email, sito e indirizzo app restano vuoti valgono info@nexiora.it, support@nexiora.it, https://nexiora.it e https://app.nexiora.it</div>
        <div style={{ display:"flex", gap:10, justifyContent:"flex-end", marginTop:18 }}>
          <button onClick={onClose} style={{ padding:"9px 16px", background:"transparent", border:"1px solid rgba(255,255,255,0.2)", borderRadius:8, color:"#fff", cursor:"pointer", fontFamily:"'Inter',sans-serif" }}>Annulla</button>
          <button onClick={salva} disabled={salvando} style={{ padding:"9px 18px", background:"#7c3aed", border:"none", borderRadius:8, color:"#fff", fontWeight:700, cursor:"pointer", opacity:salvando?0.6:1, fontFamily:"'Inter',sans-serif" }}>{salvando ? "Salvataggio…" : "Salva"}</button>
        </div>
      </div>
    </div>
  );
}
